import { passwordValidation } from "../_utils.js";
import validator from "validator";
$(document).ready(function () {
    const $submitButton = $(".js-submit");
    const $companyAccountCheckbox = $("#is_company_account_register");
    let $requiredInputs = $(".js-form input[required]");
    const $emailInput = $(".js-email");
    const $additionalEmailsInput = $(".js-additional-emails");
    const $phoneInput = $(".js-phone");

    // VALIDATION PASSWORD
    const $passwordInput = $(".js-password");
    const $passwordConfirmInput = $(".js-password-confirm");

    // ADVANTAGES MORE
    const $advantagesBtn = $(".js-advantages-btn");
    const $advantagesBlock = $(".js-advantages-block");
    $advantagesBtn.click(() => {
        $advantagesBtn.toggleClass("open");
        $advantagesBlock.animate({ height: "toggle" }, 1000);
    });

    const checkRequiredInputs = () => {
        let valid = true;
        $.each($requiredInputs, function (_, value) {
            if (
                !$(value).val() ||
                ($(value).is("[type=checkbox]") && !$(value).is(":checked"))
            ) {
                valid = false;
            }
        });
        return valid;
    };

    const checkPhone = () => {
        if (!$phoneInput.val()) return true;
        return (
            /^\+?[0-9]+$/.test($phoneInput.val()) &&
            validator.isLength($phoneInput.val(), { min: 9, max: 13 })
        );
    };

    const checkEmail = () => {
        return validator.isEmail($emailInput.val() || "");
    };

    const checkAdditionalEmails = () => {
        const raw = $additionalEmailsInput.val();
        const primaryEmail = $emailInput.val().trim().toLowerCase();
        const $inputWr = $additionalEmailsInput.closest(".form-group");
        const $errorMessage = $inputWr.find(".error-message");

        if (!raw.trim()) {
            $inputWr.removeClass("error is-invalid");
            $errorMessage.text("");
            return true;
        }

        const emails = raw
            .split(",")
            .map((e) => e.trim().toLowerCase())
            .filter((e) => e);

        const hasInvalid = emails.some((email) => !validator.isEmail(email));
        // UX-only: server does not enforce this, but catches obvious mistake early
        const hasDuplicate = emails.includes(primaryEmail);

        if (hasInvalid) {
            $inputWr.addClass("error is-invalid");
            $errorMessage.text(
                "One or more email addresses are invalid. Use commas to separate them.",
            );
            return false;
        }

        if (hasDuplicate) {
            $inputWr.addClass("error is-invalid");
            $errorMessage.text(
                "Secondary email(s) must be different from the main email.",
            );
            return false;
        }

        $inputWr.removeClass("error is-invalid");
        $errorMessage.text("");
        return true;
    };

    const passwordsMatch = () => {
        return (
            $passwordInput.val().trim() === $passwordConfirmInput.val().trim()
        );
    };

    const checkPasswordConfirm = () => {
        const passwordsAreSame = passwordsMatch();
        const $inputWr = $passwordConfirmInput.closest(".form-group");
        const $inputClientError = $inputWr.find(".error-message");
        const $inputServerError = $inputWr.find(".invalid-feedback");

        if (!passwordsAreSame) {
            $inputWr.addClass("error is-invalid");
            $inputClientError.text("Passwords must be the same");
        } else {
            $inputWr.removeClass("error is-invalid");
            $inputClientError.text("");
            $inputServerError.text("");
        }
    };

    const checkPassword = () => {
        const currentPasswordIsValid = passwordValidation(
            $passwordInput.val().trim(),
        );

        return currentPasswordIsValid;
    };
    const formValidation = () => {
        const requiredInputsAreValid = checkRequiredInputs();
        const emailIsValid = checkEmail();
        const additionalEmailsValid = checkAdditionalEmails();
        const phoneIsValid = checkPhone();
        const passwordsAreSame = passwordsMatch();
        const currentPasswordIsValid = checkPassword();
        if (
            requiredInputsAreValid &&
            currentPasswordIsValid &&
            passwordsAreSame &&
            emailIsValid &&
            phoneIsValid &&
            additionalEmailsValid
        ) {
            $($submitButton).attr("disabled", false);
        } else {
            $($submitButton).attr("disabled", true);
        }
    };

    $companyAccountCheckbox.on("change", function () {
        $requiredInputs = $(".js-form input[required]");
        formValidation();
    });

    $([$passwordInput, $passwordConfirmInput, $emailInput, $phoneInput]).each(
        function (_, elem) {
            elem.on("keyup change", function () {
                const $inputWr = $(this).closest(".form-group");
                const $inputClientError = $inputWr.find(".error-message");
                const $inputServerError = $inputWr.find(".invalid-feedback");
                $inputWr.removeClass("error is-invalid");
                $inputClientError.text("");
                $inputServerError.text("");

                formValidation();
            });
        },
    );

    $emailInput.on("focusout", function () {
        const emailIsValid = checkEmail();
        const $inputWr = $(this).closest(".form-group");
        const $inputClientError = $inputWr.find(".error-message");

        if (!emailIsValid) {
            $inputWr.addClass("error is-invalid");
            $inputClientError.text("Please enter a valid email address");
        }
        formValidation();
    });

    $additionalEmailsInput.on("focusout", function () {
        checkAdditionalEmails();
        formValidation();
    });

    $phoneInput.on("focusout", function () {
        const phoneIsValid = checkPhone();
        const $inputWr = $(this).closest(".form-group");
        const $inputClientError = $inputWr.find(".error-message");

        if (!phoneIsValid) {
            $inputWr.addClass("error is-invalid");
            $inputClientError.text("Please enter a valid phone number");
        }
        formValidation();
    });

    $passwordInput.on("focusout", function () {
        const currentPasswordIsValid = checkPassword();
        const $inputWr = $(this).closest(".form-group");
        const $inputClientError = $inputWr.find(".error-message");

        if (!currentPasswordIsValid) {
            $inputWr.addClass("error is-invalid");
            $inputClientError.text("Password must be at least 8 characters.");
        }

        if ($(this).val() && $passwordConfirmInput.val()) {
            checkPasswordConfirm();
        }

        formValidation();
    });

    $passwordConfirmInput.on("focusout", function () {
        checkPasswordConfirm();

        formValidation();
    });

    $requiredInputs.on("keyup change focus", function () {
        formValidation();
    });

    formValidation();
});
